import select from './modules/mdc/select';
import switchControl from './modules/mdc/switch';
import textField from './modules/mdc/textfield';
import table from './modules/mdc/table';
import pjax from './modules/jquery/pjax';
import autocomplete from './modules/jquery/autocomplete';
import clipboard from './modules/jquery/clipboard';
import filterSwitch from './modules/filterSwitch';
import channelFilter from './modules/channelFilter';
import snackbar from './modules/mdc/snackbar';
import tabBar from './modules/mdc/tabBar';
import accordion from './modules/accordion';
import fileUpload from './modules/fileUpload';
import collectionApi from './modules/collectionApi';
import imgBase64Download from './modules/imgBase64Download';
import qrOptionsSwitch from './modules/qrOptionsSwitch';

const $ = require('jquery');

// Keep global state of pjax known.
window.isPjaxBusy = false;

function initAll() {
    $('.checkbox-select-all').click(() => {
        $($(this).data('checkbox-select-all-selector')).prop('checked', $(this).prop('checked'));
    });

    autocomplete();
    clipboard();
    pjax();
    select();
    switchControl();
    textField();
    table();
    filterSwitch();
    channelFilter();
    tabBar();
    accordion();
    fileUpload();
    snackbar();
    collectionApi();
    imgBase64Download();
    qrOptionsSwitch();
}

$(document).ready(() => {
    initAll();

    $(document).on('pjax:send', () => {
        window.isPjaxBusy = true;
    });

    $(document).on('pjax:timeout', () => {
        window.isPjaxBusy = false;
    });

    $(document).on('pjax:complete', () => {
        initAll();
        window.isPjaxBusy = false;
    });
});
